import React from 'react';

const KeyboardIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M10 8h.01"/>
        <path d="M12 12h.01"/>
        <path d="M14 8h.01"/>
        <path d="M16 12h.01"/>
        <path d="M18 8h.01"/>
        <path d="M6 8h.01"/>
        <path d="M7 16h10"/>
        <path d="M8 12h.01"/>
        <rect width="20" height="16" x="2" y="4" rx="2"/>
    </svg>
);

export default KeyboardIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/KeyboardIcon.jsx